import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/listTitle.module.scss';
import { FlexGrid, FlexGridColumn } from '../../../../components/FlexGrid';

export const ListLayoutTitle: FC<
	React.PropsWithChildren<{
		className?: string;
	}>
> = ({ children, className }) => {
	const componentClasses = classNames(classes.listPageTitle, className);
	return (
		<FlexGrid
			className={componentClasses}
			center
		>
			<FlexGridColumn>{children}</FlexGridColumn>
		</FlexGrid>
	);
};
